import { useState } from 'react'
import { Create_Feedback } from '@graphql/mutations'
import { useApi } from '@hooks/useApi'
import { useBooks } from '@hooks/useBooks'

const useCreateFeedback = () => {
  const [isPosting, setIsPosting] = useState(false)
  const { postMutation } = useApi()

  const post = async (data, successMessage, errorMessage) => {
    setIsPosting(true)

    const res = await postMutation(
      { input: data },
      Create_Feedback,
      successMessage ? successMessage : 'Omdöme skickat.',
      errorMessage ? errorMessage : 'Något gick fel när omdömet skulle skickas.'
    )

    setIsPosting(false)
    return res
  }

  return {
    post,
    isPosting,
  }
}

export { useCreateFeedback }
